var _defs, _circle, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    color: "#ffffff",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-1",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-2",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "currentColor",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#grad-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "-50%",
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#grad-2)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    strokeWidth: 4,
    stroke: "url(#pattern)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "360 0 0",
    to: "0 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerNeutral);
export default __webpack_public_path__ + "static/media/spinner-neutral.a22bc18094188bb39f09ab9721007a76.svg";
export { ForwardRef as ReactComponent };